/**
 * Утилиты форматирования для компонентов событий
 */
import type { EventQueueStatus } from '../../../types/plantingEvents';
import i18n, { formatDate, formatDateTime } from '../../../i18n';

/**
 * Конфигурация статусов событий
 */
export const EVENT_STATUS_CONFIG: Record<EventQueueStatus, { color: string }> = {
  planned: { color: 'default' },
  pending: { color: 'orange' },
  in_progress: { color: 'blue' },
  completed: { color: 'green' },
  cancelled: { color: 'red' },
};

/** Localized event status name, resolved at render time. */
export const eventStatusLabel = (status: EventQueueStatus | string): string =>
  i18n.t(`events:status.${status}`, { defaultValue: String(status) });

/**
 * Форматирует дату в локальный формат
 */
export const formatEventDate = (date: string | null | undefined): string => {
  if (!date) return '—';
  try {
    return formatDate(date, 'short') || '—';
  } catch {
    return '—';
  }
};

/**
 * Форматирует дату и время
 */
export const formatEventDateTime = (date: string | null | undefined): string => {
  if (!date) return '—';
  try {
    return formatDateTime(date, 'short') || '—';
  } catch {
    return '—';
  }
};

/**
 * Вычисляет прогресс в процентах
 */
export const calculateProgress = (completed: number, total: number): number => {
  if (total === 0) return 0;
  return Math.round((completed / total) * 100);
};
